var _defs, _path, _circle, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _circle8, _path4, _path5, _path6, _path7, _circle9, _circle10, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpacaduras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e0b32d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.89,633a5.94,5.94,0,1,0,5.93,5.93A5.93,5.93,0,0,0,359.89,633Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 708.96,
    cy: 440.12,
    r: 5.93
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M774.74,452.91a81.72,81.72,0,0,0-80.33,67.37,81.58,81.58,0,0,0-160.66,0,81.58,81.58,0,0,0-160.66,0,81.6,81.6,0,1,0,0,28.45,81.58,81.58,0,0,0,160.66,0,81.58,81.58,0,0,0,160.66,0,81.59,81.59,0,1,0,80.33-95.82ZM372.24,542.8a79.92,79.92,0,1,1,0-16.59,82.12,82.12,0,0,0,0,16.59Zm160.66,0a79.91,79.91,0,0,1-159,0c.27-2.73.42-5.5.42-8.3s-.15-5.56-.42-8.29a79.91,79.91,0,0,1,159,0c-.27,2.73-.42,5.5-.42,8.29S532.63,540.07,532.9,542.8Zm160.66,0a79.91,79.91,0,0,1-159,0,82.12,82.12,0,0,0,0-16.59,79.91,79.91,0,0,1,159,0c-.27,2.73-.41,5.5-.41,8.29S693.29,540.07,693.56,542.8Zm81.18,71.62a80,80,0,0,1-79.48-71.62,82.12,82.12,0,0,0,0-16.59,79.92,79.92,0,1,1,79.48,88.21Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 773.4,
    cy: 533.83,
    r: 75.46,
    transform: "translate(-150.95 703.23) rotate(-45)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 613.41,
    cy: 533.83,
    r: 75.46,
    transform: "translate(-197.81 590.1) rotate(-45)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 836.04,
    cy: 674.79,
    r: 12.81
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 293.43,
    cy: 533.83,
    r: 75.46,
    transform: "translate(-291.53 363.84) rotate(-45)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 453.42,
    cy: 533.83,
    r: 75.46,
    transform: "translate(-244.67 476.97) rotate(-45)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 209.43,
    cy: 425.87,
    r: 20.18,
    transform: "translate(-147.03 112.56) rotate(-22.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M902.12,616.41a12.82,12.82,0,1,0,12.81,12.82A12.81,12.81,0,0,0,902.12,616.41Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 283.72,
    cy: 413.06,
    r: 12.81
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.11,470.87a12.81,12.81,0,1,0,12.81,12.81A12.8,12.8,0,0,0,168.11,470.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M693.56,526.21a79.91,79.91,0,0,0-159,0,82.12,82.12,0,0,1,0,16.59,79.91,79.91,0,0,0,159,0q-.4-4.09-.41-8.3C693.15,531.71,693.29,528.94,693.56,526.21Zm-80.15,83.08a75.46,75.46,0,1,1,75.46-75.46A75.45,75.45,0,0,1,613.41,609.29Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M774.74,454.59a80,80,0,0,0-79.48,71.62,82.12,82.12,0,0,1,0,16.59,79.92,79.92,0,1,0,79.48-88.21Zm-1.34,154.7a75.46,75.46,0,1,1,75.46-75.46A75.46,75.46,0,0,1,773.4,609.29Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M532.9,526.21a79.91,79.91,0,0,0-159,0c.27,2.73.42,5.5.42,8.29s-.15,5.57-.42,8.3a79.91,79.91,0,0,0,159,0c-.27-2.73-.42-5.5-.42-8.3S532.63,528.94,532.9,526.21Zm-79.48,83.08a75.46,75.46,0,1,1,75.46-75.46A75.45,75.45,0,0,1,453.42,609.29Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 232.33,
    cy: 657.1,
    r: 14.36
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.98,
    cy: 419.83,
    r: 14.36
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M880.44,368.19H199.56a68.68,68.68,0,0,0-68.67,68.67V643.14a68.68,68.68,0,0,0,68.67,68.67H880.44a68.68,68.68,0,0,0,68.67-68.67V436.86A68.68,68.68,0,0,0,880.44,368.19ZM709,434.19a5.94,5.94,0,1,1-5.93,5.93A5.94,5.94,0,0,1,709,434.19ZM283.72,400.24a12.82,12.82,0,1,1-12.82,12.82A12.82,12.82,0,0,1,283.72,400.24ZM168.11,496.49a12.81,12.81,0,1,1,12.81-12.81A12.8,12.8,0,0,1,168.11,496.49Zm21.13-70.62a20.19,20.19,0,1,1,20.19,20.19A20.18,20.18,0,0,1,189.24,425.87Zm170.65,219a5.94,5.94,0,1,1,5.93-5.94A5.93,5.93,0,0,1,359.89,644.89ZM836,687.6a12.82,12.82,0,1,1,12.82-12.81A12.82,12.82,0,0,1,836,687.6Zm-61.3-71.5a81.73,81.73,0,0,1-80.33-67.37,81.58,81.58,0,0,1-160.66,0,81.58,81.58,0,0,1-160.66,0,81.6,81.6,0,1,1,0-28.45,81.58,81.58,0,0,1,160.66,0,81.58,81.58,0,0,1,160.66,0,81.59,81.59,0,1,1,80.33,95.82ZM902.12,642a12.82,12.82,0,1,1,12.81-12.81A12.81,12.81,0,0,1,902.12,642Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.24,526.21a79.92,79.92,0,1,0,0,16.59,82.12,82.12,0,0,1,0-16.59Zm-78.81,83.08a75.46,75.46,0,1,1,75.46-75.46A75.45,75.45,0,0,1,293.43,609.29Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpacaduras);
export default __webpack_public_path__ + "static/media/empacaduras.03c0e07c7040dba7a13f005184959bec.svg";
export { ForwardRef as ReactComponent };